export default function password(){
    const senhaInput = document.getElementById('senha');
    const mostrarOcultarButton = document.getElementById('mostrarOcultar');

    mostrarOcultarButton.addEventListener('click', function() {
        if (senhaInput.type === 'password') {
            senhaInput.type = 'text';
            mostrarOcultarButton.innerHTML = '<i class="fas fa-low-vision"></i>';
        } else {
            senhaInput.type = 'password';
            mostrarOcultarButton.innerHTML = '<i class="far fa-eye"></i>';
        }
    });
}